import { SvgIcon } from '@mui/material';
import { memo } from 'react';

const LogicalSpaceIcon = (props) => (
  <SvgIcon
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    stroke='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g mask='url(#mask0_521_6023)'>
      <path
        fill='none'
        stroke='currentColor'
        strokeWidth='1.0'
        strokeLinecap='round'
        strokeDasharray='7'
        strokeDashoffset='0.0'
        d='M 2.58349,11.964206 V 2.6015283 l 9.362678,4.739e-4'
        id='path1'
      />
      <path
        fill='none'
        stroke='currentColor'
        strokeWidth='1.0'
        strokeLinecap='round'
        strokeDasharray='7'
        strokeDashoffset='0.0'
        d='M 21.41651,11.964206 V 2.6020022 h -9.362678'
        id='path2'
      />
      <path
        fill='none'
        stroke='currentColor'
        strokeWidth='1.0'
        strokeLinecap='round'
        strokeDasharray='7'
        strokeDashoffset='0.0'
        d='m 2.58349,11.964206 v 9.36137 h 9.362678'
        id='path3'
      />
      <path
        fill='none'
        stroke='currentColor'
        strokeWidth='1.0'
        strokeLinecap='round'
        strokeDasharray='7'
        strokeDashoffset='0.0'
        d='m 21.41651,11.964206 v 9.362677 l -9.362678,-0.0013'
        id='path4'
      />
    </g>
  </SvgIcon>
);

export default memo(LogicalSpaceIcon);
